import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Viewer from '../components/Viewer';
import Card from '../components/Card';
import Modal from '../components/Modal';

export default function ViewYourStone(props) {
  const { stoneId } = useParams();
  const prefix = stoneId ? stoneId.charAt(0).toLowerCase() : props.prefix;
  const searchInput = useRef(null);
  const history = useHistory();
  const [stoneIdInputValid, setStoneIdValidity] = useState(true);

  console.log('Prefix:', prefix);

  useEffect(() => {
    const highlightedStones = document.querySelectorAll('.added-to-basket');

    if (highlightedStones !== undefined && highlightedStones.length > 0) {
      highlightedStones.forEach((stone) => {
        stone.classList.remove('added-to-basket');
      });
    }

    if (stoneId) {
      const stone = document.querySelector('#' + stoneId.toLowerCase());

      if (stone) {
        stone.classList.add('added-to-basket');
      }
    }
  }, [stoneId]);

  const search = (e) => {
    e.preventDefault();

    if (searchInput.current.checkValidity()) {
      history.push('/id/' + searchInput.current.value);
    }
  };

  const validateStoneIdInput = (e) => {
    if (e.target.checkValidity() || e.target.value === '') {
      setStoneIdValidity(true);
    } else {
      setStoneIdValidity(false);
    }
  };

  return (
    <>
      <div className="container pt-5 pb-3 text-center">
        <h1>Find the stone you’ve sponsored</h1>
        <form onSubmit={search} noValidate>
          <label htmlFor="search">
            Enter your full stone ID to find your stone (e.g. s13576) and click on the search button <br/>
            You will need to zoom in close and move around a wall to find the smaller stones
          </label>

          <div className="row mx-auto mb-3" style={{ maxWidth: '700px' }}>
            <input
              type="text"
              className="form-control col-7"
              pattern="[eEnNwWsS]{1}[0-2]{1}[0-9]{4}"
              required={true}
              ref={searchInput}
              id="search"
              style={{ border: 'solid 1px #888' }}
              defaultValue={stoneId}
              maxLength={6}
              onBlur={(e) => {
                validateStoneIdInput(e);
              }}
            />

            <button className="btn btn-dark btn-search col-4">
              <span>Search</span>
              <img src="/images/chevron-right-white.svg" alt="Chevron Right Icon" />
            </button>
          </div>

          {!stoneIdInputValid ? (
            <div
              className="mx-auto text-left text-danger"
              style={{ maxWidth: '700px' }}
            >
              <p>
                <b>Stone ID must meet the following criteria:</b>
              </p>
              <ul>
                <li>Must be six characters long</li>
                <li>First character must be an N, W, S or E</li>
                <li>Second character must be a 0, 1 or 2</li>
                <li>The four remaining characters must be numbers</li>
              </ul>
            </div>
          ) : null}
        </form>
      </div>

      <div className="bg-light">
        <div className="container py-4">
          <Viewer prefix={prefix} slug="/" disableBasket={true} />

          <div className="row mt-4">
            <div className="col-lg-12">            
              <Card subTitle="WHY NOT VISIT YOUR STONE IN PERSON?" buttonTxt="BUY TOWER TICKETS" externalLink="true" buttonUrl='https://www.hrp.org.uk/tower-of-london/visit/tickets-and-prices/#gs.4xg07l'/>
            </div>
          </div>

        </div>
      </div>

      <Modal />
    </>
  );
}
